import { CreateEnquiryFlow } from '../create-enquiry/CreateEnquiryFlow';

export const CreateEnquiryPage = () => {
    return <CreateEnquiryFlow />;
};
